import { render, staticRenderFns } from "./DelThisGroup.vue?vue&type=template&id=58f880aa&scoped=true&"
import script from "./DelThisGroup.vue?vue&type=script&lang=js&"
export * from "./DelThisGroup.vue?vue&type=script&lang=js&"
import style0 from "./DelThisGroup.vue?vue&type=style&index=0&id=58f880aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f880aa",
  null
  
)

export default component.exports